import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../Components/ContactDetail.css';
const ContactDetails = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_3g9zkhb', 'template_gcpdvnc', form.current, 'eZMjSqj6Hh33imitJ')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
    };
    return (
        <div>
            <div className='ContactDetail'>
                <h2>Contact Me</h2>
                <div className='addressForms'>
                    <div className='address'>
                        <div className='phone'><i class="fa-solid fa-phone"></i><span>+91-7061027538</span></div>
                        <div className='phone'><i class="fa-regular fa-envelope"></i><span>kumarishav812@gmail.com</span></div>
                        <div className='phone'><i class="fa-solid fa-location-dot"></i><span>Jaipur, India</span></div>
                    </div>
                    <div className='form'>
                        <form ref={form} onSubmit={sendEmail}>
                            <label>Your Name</label>
                            <input type="text" name="user_name" className='box' />
                            <label>Your Email</label>
                            <input type="email" name="user_email" className='box' />
                            <label>Your Message</label>
                            <textarea name="message" />
                            <input type="submit" value="Send" className='input' />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ContactDetails;